module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/93.9994ab0c.png";